module.exports = __webpack_public_path__ + "static/media/illustrationMob.c56bd99b.png";